import { Gltf } from './GltfTypes';

const EXTENSION_KEY = '_BONE_COLLISION';

/** Sparse per-bone radius overrides. Only bones with non-default radii are stored. */
export interface BoneCollisionConfig {
  bones: BoneRadiusOverride[];
}

export interface BoneRadiusOverride {
  joint: string;
  radius: number;
  shape?: 'capsule' | 'sphere'; // omitted = use default
}

export function readBoneCollisionExtras(json: Gltf): BoneCollisionConfig | null {
  const skin = json.skins?.[0];
  if (!skin?.extras?.[EXTENSION_KEY]) return null;
  const raw = skin.extras[EXTENSION_KEY];
  if (!raw || typeof raw !== 'object') return null;
  return raw as BoneCollisionConfig;
}
